import { createElement } from 'react';

export default function switchable(getComponent) {
  var mapProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  return function (props) {
    var component = getComponent(props);
    if (component == null) {
      return null;
    }
    return createElement(component, mapProps(props));
  };
}